// formActions.js
export const setFirstInfo = (formData) => {
    return {
      type: 'SET_FIRST_INFO',
      payload: formData,
    };
};

export const setCertType = (formData) => {
  return {
    type: 'SET_CERT_TYPE',
    payload: formData,
  };
};
export const setUniqueData = (formData) => {
  return {
    type: 'SET_UNIQUE_DATA',
    payload: formData,
  };
  };
export const setTimeStamp = (formData) => {
  return {
    type: 'SET_TIME_STAMP',
    payload: formData,
  };
};